<div class="tooltip"
  [ngClass]="['tooltip--'+position]"
  [style.left]="left + 'px'" [style.top]="top + 'px'">
  @for (t of tooltip; track t) {
    <div>{{t}}<br></div>
  }
</div>